import React, {memo, useEffect} from "react";
import {Route, Switch, useHistory, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
// import {handelOpenModalLoginAndRegister} from "../../../../redux/actions/modals/modalLoginAndRegister";
import {handelChangeStatusPageNavigation} from "../../../../redux/actions/navigation";
import HeaderBase from "./HeaderBase";
import HeaderBaseWithWideLogo from "./HeaderBaseWithWideLogo";
import HeaderWithSearch from "./HeaderWithSearch";
import {handelOpenModalShoppingCard} from "../../../../redux/actions/modals/modalShoppingCard";
import HeaderWithShopping from "./HeaderWithShopping";
import HeaderWithBackAndWideLogo from "./HeaderWithBackAndWideLogo";
import HeaderPageListStores from "../../pages/stores/ListStores/Header";
import MenuLeft from "../menu/MenuLeft";
import {toast} from "react-toastify";
import ImportModals from "../ImportModals";
import Progress from "../../../router/Progress";

const Headers = () => {
        const dispatch = useDispatch();
        let location = useLocation();
        const history = useHistory();
        const {statusPage} = useSelector(state => state.navigation);
        const {status_progress_bar} = useSelector(state => state.progressBar);
        // const {token} = useSelector(state => state.user);
        const {carts, storeSelected} = useSelector(state => state.shoppingCart);
        const store = useSelector(state => state.stores.list_stores.find(storeItem => (storeSelected && storeItem.id === storeSelected.id)));

        useEffect(() => {
            if (statusPage !== location.pathname) dispatch(handelChangeStatusPageNavigation(location.pathname));
        });

        const goToPageStores = () => {
            history.push('/stores');
        }

        const openModalShoppingCard = () => {
            // if (token) {
            //     if (store && carts.length > 0) {
            //         history.push(`/stores/${store.id}`);
            //         dispatch(handelOpenModalShoppingCard());
            //     } else {
            //         goToPageStores();
            //         toast.warning(`سبد خرید شما خالی میباشد. لطفا ابتدا یک فروشگاه انتخاب کنید.`
            //             , {position: toast.POSITION.BOTTOM_CENTER});
            //     }
            // } else {
            //     goToPageStores();
            //     dispatch(handelOpenModalLoginAndRegister());
            // }
            if (store && carts.length > 0) {
                // history.push(`/stores/${store.id}`);
                dispatch(handelOpenModalShoppingCard());
            } else {
                goToPageStores();
                toast.warning(`سبد خرید شما خالی میباشد. لطفا ابتدا یک فروشگاه انتخاب کنید.`
                    , {position: toast.POSITION.BOTTOM_CENTER});
            }
        };

        return (
            <div id={'base-box-flex-navigation-fixed'}>
                <Progress isAnimating={status_progress_bar}/>
                <ImportModals/>
                <Switch>
                    <Route exact path={'/stores'}>
                        <MenuLeft/>
                        <HeaderPageListStores/>
                    </Route>
                    <Route exact path={'/stores/:store'}>
                        <HeaderWithShopping/>
                    </Route>
                    <Route path={'/stores/:store/'}>
                        <HeaderWithSearch openModalShoppingCard={openModalShoppingCard}/>
                    </Route>
                    <Route path={'/more-pages'}>
                        <HeaderBase openModalShoppingCard={openModalShoppingCard}/>
                    </Route>
                    <Route path={'/intro'}>
                        <HeaderBaseWithWideLogo openModalShoppingCard={openModalShoppingCard}/>
                    </Route>
                    <Route exact path={'/food-package/:id'}>
                        <HeaderWithBackAndWideLogo openModalShoppingCard={openModalShoppingCard}/>
                    </Route>
                    <Route exact path={'/my-food-pack/:id'}>
                        <HeaderWithBackAndWideLogo openModalShoppingCard={openModalShoppingCard}/>
                    </Route>


                    <Route exact path={'/fudu'}>
                        <HeaderWithShopping/>
                    </Route>
                    <Route path={'/fudu'}>
                        <HeaderWithSearch openModalShoppingCard={openModalShoppingCard}/>
                    </Route>
                </Switch>
            </div>
        );
    }
;
export default memo(Headers);
